export default "__VITE_ASSET__CcmxOXdo__"